<template>
   <div class="pb-card" :class="{ 'is-hoverable': hoverable }">
      <div class="pb-card-img">
         <div class="pb-card-img-info">
            <small>{{ imgInfo }}</small>
         </div>
         <slot name="image">
            <img :src="imageResource(imgSrc, 240)" alt="thumbnail"/>
         </slot>
      </div>
      <div class="pb-card-content">
         <slot name="content">
            {{ content }}
         </slot>
      </div>
   </div>
</template>
<script>
export default {
   name: 'pb-card',
   props: {
      hoverable: {
         type: Boolean,
         default: true
      },
      imgSrc: {
         type: String
      },
      imgInfo: {
         type: String
      },
      content: {
         type: String
      }
   },
}

</script>

<style lang="scss" scoped>
@import "~@shared/_assets/scss/constants";

.pb-card {
   cursor: default;

   &.is-hoverable {
      cursor: pointer;
   }

   flex: 1 0 0%;

   .pb-card-img {
      position: relative;
      background: $color-neutral-light;
      flex: 1 1 auto;
      min-height: 275px;

      img {
         padding: 40px;
         width: 100%;
         object-fit: contain;
         margin: auto;
         height: 275px;
      }

      .pb-card-img-info {
         display: none;
         text-overflow: ellipsis;
         white-space: nowrap;
         width: 100%;
         padding: 10px;
         border-right: 20px solid transparent;
         overflow: hidden;
         position: absolute;
         text-align: right;
         z-index: 999;
      }
   }

   .pb-card-content {
      text-align: center;
      margin: auto;
      padding: 10px;
      color: #111111;
      font-family: $font-robo;
      font-size: 15px;
      font-weight: 300;
      overflow: hidden;
      text-overflow: ellipsis;
   }

   &.is-hoverable:hover {
      box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.3);

      .pb-card-img-info {
         display: block;
      }
   }
}

</style>